import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpTypeaheadComponent from './adpTypeahead.component';

let adpTypeaheadModule = angular.module('adpTypeahead', [
  uiRouter
])

.component('adpTypeahead', adpTypeaheadComponent)

.name;

export default adpTypeaheadModule;



// WEBPACK FOOTER //
// ./src/app/components/adpTypeahead/adpTypeahead.js